document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.register-decanter-tab');
    var contents = document.querySelectorAll('.register-decanter-tab-content');

    // Function to hide all tabs' content and remove active class
    function resetTabs() {
        contents.forEach(function (content) {
            content.style.display = 'none';
        });
        tabs.forEach(function (tab) {
            tab.classList.remove('active');
        });
    }

    // Function to show tab content and add active class
    function activateTab(tab) {
        var tabId = tab.getAttribute('data-tab-id');
        var content = document.getElementById('tab-content-' + tabId);
        resetTabs();
        tab.classList.add('active');
        content.style.display = 'block';
    }

    // Event listener for each tab
    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
            activateTab(this);
        });
    });

    // Initialize with the first tab active
    if (tabs.length > 0) {
        activateTab(tabs[0]);
    }
});

document.addEventListener('DOMContentLoaded', function () {

    var swiper = new Swiper(".register-decanter-slider", {
        slidesPerView: 1,
        pagination: true,
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },
        pagination: {
            el: ".swiper-pagination"
        },
    });

});